// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ef79b73","455":"e2264c65","644":"6a07475f"}[chunkId] + ".chunk.js";
};